import type { HTMLAttributes } from 'react';
import clsx from 'clsx';
import type { InterfaceColor, SecondaryColor } from './colors';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  purpose?: 'primary' | 'outline' | 'discreet' | 'default' | 'flat';
  color?: InterfaceColor | SecondaryColor;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isPill?: boolean;
}

export const Badge = ({
  purpose = 'primary',
  color = 'primary',
  size = 'md',
  isPill = false,
  children,
  ...spanProps
}: BadgeProps) => {
  return (
    <span
      className={clsx(`badge badge-${size} ${getBadgeClass(purpose, color)}`, {
        'rounded-pill': isPill,
      })}
      {...spanProps}
    >
      {children}
    </span>
  );
};

const getBadgeClass = (
  purpose: Required<BadgeProps['purpose']>,
  color: Required<BadgeProps['color']>,
) => {
  if (purpose === 'primary') {
    return `badge-${color}`;
  }

  if (purpose === 'default') {
    return 'badge-default';
  }

  return `badge-${purpose}-${color}`;
};
